<template>
  <div class="monthlyCard">
    <div class="condition">
      <el-col :xs="24" :md="24" style="text-align: right;">
        <el-button type="primary" @click="add()"><i class="el-icon-plus">新增放行车辆</i></el-button>
      </el-col>
    </div>
    <el-table :data="tableData" style="width: 100%" ref="inTable">
      <el-table-column prop="place_name" label="场地" min-width="150" align="center" fixed>
        <template slot-scope="scope">
          {{scope.row.place_name}}
        </template>
      </el-table-column>
      <el-table-column prop="plate_code" label="车牌" min-width="150" align="center">
      </el-table-column>
      <el-table-column label="有效期" min-width="250" align="center">
        <template slot-scope="scope">
          <el-date-picker
            v-model="scope.row.start_at"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择"
            :picker-options="pickerOptions"
            :clearable=false
            prefix-icon=" "
            suffix-icon=" "
            @change="setStartAt(scope.row)"
            >
          </el-date-picker>
          ~
          <el-date-picker
            v-model="scope.row.end_at"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="请选择"
            :picker-options="pickerOptions"
            :clearable=false
            prefix-icon=" "
            suffix-icon=" "
            @change="setEndAt(scope.row)"
            >
          </el-date-picker>
        </template>
      </el-table-column>
      <el-table-column prop="is_enable" label="效期启用状态" min-width="60" align="center">
        <template slot-scope="scope">
          {{showIsEnable(scope.row.is_enable)}}
        </template>
      </el-table-column>
      <el-table-column prop="is_unlimited" label="系统白名单" min-width="60" align="center">
        <template slot-scope="scope">
          {{showLimited(scope.row.is_unlimited)}}
        </template>
      </el-table-column>
      <el-table-column label="操作" min-width="180" align="center" fixed="right">
        <template slot-scope="scope">
          <el-button :type="(scope.row.is_enable==1)?'danger':'primary'" @click="setEnable(scope.row)">{{showIsEnableBtn(scope.row.is_enable)}}</el-button>
          <el-button :type="(scope.row.is_unlimited==1)?'danger':'primary'" @click="setUnlimited(scope.row)">{{showLimitedBtn(scope.row.is_unlimited)}}</el-button>
        </template>
      </el-table-column>
    </el-table>
    <pagination @handleSizeChange="handleSizeChange" @handleCurrentChange="handleCurrentChange" :page="form.page"
      :size="form.size" :total="total"></pagination>


    <!-- 新增/编辑-月卡 -->
    <modal @submit="addSubmit()"
      :obj="{title:'新增放行车辆',dialog:dialog, dialogText:'dialog',ref:'addForm',form:addForm, width:'500px'}">
      <el-form :model="addForm" status-icon ref="addForm" class="demo-addForm">

        <el-form-item prop="place_id" label="选择场地" class="el-form-left">
          <loadSelect ref="loadSelect"
            :obj="{
              modelVal:addForm.place_id,
              disabled:false,
              optionVal:'place_id',
              optionName:'place_name',
              placeholder:'请选择'}"
            :url="'deviceManage/listPlace'" :formData="formFieldData" :parameter="false" @changeFn="changePlatField">
          </loadSelect>
        </el-form-item>
        <el-form-item prop="plate_code" label="车牌号码" class="el-form-left">
          <el-input type="text" v-model="addForm.plate_code" autocomplete="off" placeholder="车牌号码" :disabled="edit"></el-input>
        </el-form-item>
        <el-form-item prop="start_at" label="启用时间" class="el-form-left">
          <el-date-picker
            v-model="addForm.daterange"
            type="datetimerange"
            :picker-options="pickerOptions"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            align="right">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="启用效期" class="el-form-top">
          <el-switch
          v-model="addForm.is_enable"
          active-color="#ff4949"
          inactive-color="#cccccc"
          active-text="启用"
          inactive-text="停用"
          active-value=1
          inactive-value=0
          >
          </el-switch>
        </el-form-item>
        <el-form-item label="白名单" class="el-form-top">
          <el-switch
          v-model="addForm.is_unlimited"
          active-color="#ff4949"
          inactive-color="#cccccc"
          active-text="白名单用户"
          inactive-text="一般用户"
          active-value=1
          inactive-value=0
          >
          </el-switch>
        </el-form-item>
      </el-form>
    </modal>
  </div>
</template>

<script>
  import Util from '../../Util'
  import modal from '../../components/modal'
  import pagination from "../../components/pagination"
  import loadSelect from "../../components/loadSelect"
  export default {
    components: {
      modal,
      pagination,
      loadSelect,
    },
    data() {
      return {
        placeId: '',
        total: 0,
        form: {
          page: 1,
          size: 10,
        },
        formFieldData: { //场地分页
          page: 1,
          size: 50
        },
        pickerOptions: {
        },
        addForm: {},
        dialog: false,
        edit: false,
        tableData: [],
        statusList: [{
          value: 1,
          label: '有效'
        }, {
          value: 2,
          label: '过期'
        }, ],
        cardList: []
      }
    },
    computed: {

    },
    mounted() {
      this.getList();
    },
    methods: {
      changePlatField(val) {
        console.log(val);
        this.addForm.place_id = val;
        // this.platId = val
        // this.openForm.platDeviceId = ""
        // this.openForm.deviceId = ""
      },
      setEnable(val) {
        let that = this;
        console.log(val);
        let params = {};
        params['id'] = val.id;
        params['is_enable'] = val.is_enable;
        params['plate_code'] = val.plate_code;
        params['place_id'] = val.place_id;
        console.log(params);
        let title = val.is_enable == 1 ? "确定停用？" : "确定启用？";
        this.$confirm(title, '效期操作', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            callback: action => {
              if (action === 'confirm') {
                this.$http.post(`${Util.searchURL}deviceManage/updatePassCarEnable`, params)
                .then(
                  res => {
                    if (res.data.code === 200) {
                      let d = res.data.data
                      that.getList();
                    }
                  },
                  err => {
                    console.log(err);
                  }
                );
              } else {
                console.log("取消");
              }
            }
        });
      },
      setUnlimited(val) {
        let that = this;
        console.log(val);
        let params = {};
        params['id'] = val.id;
        params['is_unlimited'] = val.is_unlimited;
        params['plate_code'] = val.plate_code;
        params['place_id'] = val.place_id;
        console.log(params);
        let title = val.is_unlimited == 1 ? "设为一般用户" : "设为白名单用户";
        this.$confirm(title, '白名单用户', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            callback: action => {
              if (action === 'confirm') {
                this.$http.post(`${Util.searchURL}deviceManage/updatePassCarUnlimited`, params)
                .then(
                  res => {
                    if (res.data.code === 200) {
                      let d = res.data.data
                      that.getList();
                    }
                  },
                  err => {
                    console.log(err);
                  }
                );
              } else {
                console.log("取消");
              }
            }
        });
      },
      setStartAt(val) {
        let that = this;
        console.log(val);
        let params = {};
        params['id'] = val.id;
        params['start_at'] = val.start_at;
        params['plate_code'] = val.plate_code;
        params['place_id'] = val.place_id;
        console.log(params);
        let title = "设定生效时间";
        this.$confirm(title, '通行效期设置', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            callback: action => {
              if (action === 'confirm') {
                this.$http.post(`${Util.searchURL}deviceManage/updatePassCarStartAt`, params)
                .then(
                  res => {
                    if (res.data.code === 200) {
                      let d = res.data.data
                      that.getList();
                    }
                  },
                  err => {
                    console.log(err);
                  }
                );
              } else {
                console.log("取消");
              }
            }
        });
      },
      setEndAt(val) {
        let that = this;
        console.log(val);
        let params = {};
        params['id'] = val.id;
        params['end_at'] = val.end_at;
        params['plate_code'] = val.plate_code;
        params['place_id'] = val.place_id;
        console.log(params);
        let title = "失效时间设置";
        this.$confirm(title, '通行效期设置', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
            callback: action => {
              if (action === 'confirm') {
                this.$http.post(`${Util.searchURL}deviceManage/updatePassCarEndAt`, params)
                .then(
                  res => {
                    if (res.data.code === 200) {
                      let d = res.data.data
                      that.getList();
                    }
                  },
                  err => {
                    console.log(err);
                  }
                );
              } else {
                console.log("取消");
              }
            }
        });
      },
      add(val) {
        this.dialog = true
        if (val) {
          this.edit = true
        } else {
          this.edit = false
          if (this.$refs['addForm']) {
            this.$refs['addForm'].resetFields();
          }
        }
      },
      addSubmit() {
        this.$refs["addForm"].validate((valid) => {
          if (valid) {
            this.$http.post(`${Util.operateURL}deviceManage/addCar`, this.addForm).then(
              res => {
                if (res.data.code === 200) {
                  let d = res.data.data
                  Util.message("suc", res.data.desc)
                } else {
                  Util.message("err", res.data.desc)
                }
              },
              err => {
                console.log(err);
              }
            );
          } else {
            return false;
          }
        });
      },
      showIsEnable(val) {
        switch (val) {
          case 0:
            return "未启用";
            break;
          case 1:
            return "启用";
            break;
        }
      },
      showIsEnableBtn(val) {
        switch (val) {
          case 0:
            return "启用";
            break;
          case 1:
            return "未启用";
            break;
        }
      },
      showLimited(val) {
        switch (val) {
          case 0:
            return "一般授权";
            break;
          case 1:
            return "白名单用户";
            break;
        }
      },
      showLimitedBtn(val) {
        switch (val) {
          case 0:
            return "白名单用户";
            break;
          case 1:
            return "一般授权";
            break;
        }
      },
      getList() {
        this.$http.post(`${Util.searchURL}deviceManage/listCar`, this.form)
        .then(
          res => {
            if (res.data.code === 200) {
              let d = res.data.data
              this.totalMessage = d.count_info || null
              this.tableData = d.data
              this.total = d.pageInfo.total
            }
          },
          err => {
            console.log(err);
          }
        );
      },
      handleSizeChange(val) {
        this.form.page = 1
        this.form.size = val
        this.getList()
      },
      //   改变页数时
      handleCurrentChange(val) {
        this.form.page = val
        this.getList()
      },
    }

  }

</script>

<style lang="less" scoped>
  .monthlyCard {
    .condition {
      margin-bottom: 20px;
    }

    .btn {
      button {
        padding: 10px 20px;
      }
    }

    .money {
      span {
        color: red;
        font-size: 20px
      }
    }

    .demo-addForm {
      padding: 0px 20px;

      .btn {
        width: 100%;
        margin-top: 30px
      }
    }
  }

  .el-form-item__content {
    margin-right: 100px
  }

  @media (min-width: 1200px) {
    .btn {
      position: relative;
      top: 65px;
    }
  }

  @media (max-width: 1200px) {
    .btn {
      position: relative;
      top: 189px;
    }
  }

  @media (max-width: 990px) {
    .btn {
      position: relative;
      top: 0px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/page/passCar/index.vue